(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  if (!window.PesoRunwayFacetContext) {
    window.PesoRunwayFacetContext = true;

    document.addEventListener('facet:update', (event) => {
      if (!event.detail?.url) return;

      const targetUrl = event.detail.url instanceof URL ? event.detail.url : new URL(event.detail.url, window.location.origin);
      const currentUrl = new URL(window.location.href);

      ['peso_moment', 'peso_route', 'peso_words'].forEach((param) => {
        if (targetUrl.searchParams.has(param)) return;
        currentUrl.searchParams.getAll(param).forEach((value) => targetUrl.searchParams.append(param, value));
      });

      targetUrl.searchParams.delete('page');
      event.detail.url = targetUrl;
    }, true);

    document.addEventListener('click', (event) => {
      const control = event.target.closest('[data-peso-grouped-facet-remove]');
      if (!control) return;

      event.preventDefault();
      event.stopPropagation();

      const url = new URL(window.location.href);
      const param = control.dataset.param;
      const valuesToRemove = [...control.querySelectorAll('[data-peso-grouped-value]')].map((item) => item.dataset.pesoGroupedValue);
      const remainingValues = url.searchParams.getAll(param).filter((value) => !valuesToRemove.includes(value));

      url.searchParams.delete(param);
      remainingValues.forEach((value) => url.searchParams.append(param, value));
      url.searchParams.delete('page');
      url.searchParams.set('section_id', control.dataset.sectionId);
      url.hash = 'catalog';
      control.dispatchEvent(new CustomEvent('facet:update', { bubbles: true, detail: { url } }));
    }, true);
  }

  if (!customElements.get('peso-visual-filter')) {
    class PesoVisualFilter extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.boundClick = this.onClick.bind(this);
        this.boundKeydown = this.onKeydown.bind(this);
        this.boundLoadingStart = () => this.setAttribute('aria-busy', 'true');
        this.boundLoadingEnd = () => this.removeAttribute('aria-busy');
        this.addEventListener('click', this.boundClick, true);
        this.addEventListener('keydown', this.boundKeydown);
        document.documentElement.addEventListener('theme:loading:start', this.boundLoadingStart);
        document.documentElement.addEventListener('theme:loading:end', this.boundLoadingEnd);
        requestAnimationFrame(() => this.centerActiveChoices());
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.boundClick, true);
        this.removeEventListener('keydown', this.boundKeydown);
        document.documentElement.removeEventListener('theme:loading:start', this.boundLoadingStart);
        document.documentElement.removeEventListener('theme:loading:end', this.boundLoadingEnd);
        this.initialized = false;
      }

      onClick(event) {
        const control = event.target.closest('[data-peso-runway-choice]');
        if (!control || !this.contains(control)) return;

        event.preventDefault();
        event.stopPropagation();

        const url = this.buildUrl(control);
        if (!url) return;

        this.setAttribute('aria-busy', 'true');
        this.dispatchEvent(new CustomEvent('facet:update', {
          bubbles: true,
          detail: { url }
        }));
      }

      onKeydown(event) {
        if (event.key !== ' ') return;
        const control = event.target.closest('[data-peso-runway-choice]');
        if (!control || !this.contains(control)) return;
        event.preventDefault();
        control.click();
      }

      centerActiveChoices() {
        const scrollX = window.scrollX;
        const scrollY = window.scrollY;

        this.querySelectorAll('.peso-runway__piece-row, .peso-runway__shape-row, .peso-runway__style-row').forEach((row) => {
          const selectedChoice = row.querySelector('.is-selected');
          if (!selectedChoice || row.scrollWidth <= row.clientWidth + 1) return;
          selectedChoice.scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'center' });
        });

        window.scrollTo({ left: scrollX, top: scrollY, behavior: 'auto' });
      }

      buildUrl(control) {
        const url = new URL(window.location.href);
        const kind = control.dataset.kind;
        const canonical = control.dataset.canonical;
        const members = [...control.querySelectorAll('[data-peso-filter-member]')];
        const pieceParam = this.getAttribute('piece-param');
        const shapeParam = this.getAttribute('shape-param');
        const styleParam = this.getAttribute('style-param');
        const priceMinParam = this.getAttribute('price-min-param');
        const priceMaxParam = this.getAttribute('price-max-param');
        let param = null;

        if (kind === 'piece') param = pieceParam;
        if (kind === 'shape') param = shapeParam;
        if (kind === 'style') param = styleParam;

        if (kind !== 'price' && !param) return null;

        if (kind === 'piece') {
          url.searchParams.delete(param);
          url.searchParams.delete(shapeParam);
          url.searchParams.delete(styleParam);
          url.searchParams.delete(priceMinParam);
          url.searchParams.delete(priceMaxParam);
          if (canonical !== 'all') {
            members.forEach((member) => url.searchParams.append(param, member.dataset.value));
          }
        } else if (kind === 'shape' || kind === 'style') {
          if (!members.length) return null;
          const memberValues = members.map((member) => member.dataset.value);
          const activeValues = url.searchParams.getAll(param);
          const choiceIsActive = memberValues.some((value) => activeValues.includes(value));

          url.searchParams.delete(param);
          if (!choiceIsActive) memberValues.forEach((value) => url.searchParams.append(param, value));
        } else if (kind === 'price') {
          if (!priceMinParam || !priceMaxParam) return null;
          const priceMin = control.dataset.priceMin || '';
          const priceMax = control.dataset.priceMax || '';
          const currentMin = url.searchParams.get(priceMinParam) || '';
          const currentMax = url.searchParams.get(priceMaxParam) || '';
          const choiceIsActive = currentMin === priceMin && currentMax === priceMax;

          url.searchParams.delete(priceMinParam);
          url.searchParams.delete(priceMaxParam);
          if (!choiceIsActive) {
            if (priceMin) url.searchParams.set(priceMinParam, priceMin);
            if (priceMax) url.searchParams.set(priceMaxParam, priceMax);
          }
        } else {
          return null;
        }

        url.searchParams.delete('page');
        url.searchParams.set('section_id', this.getAttribute('section-id'));
        url.hash = 'catalog';
        return url;
      }
    }

    customElements.define('peso-visual-filter', PesoVisualFilter);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["peso-moment-discovery"] && !Shopify.designMode) return;
  try {
    
    if (!customElements.get('peso-catalog-discovery')) {
      class PesoCatalogDiscovery extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;
          this.track = this.querySelector('[data-peso-track]');
          this.gallery = this.querySelector('[data-peso-gallery]');
          this.tabs = [...this.querySelectorAll('[data-peso-moment]')];
          this.sequence = this.tabs.map((tab) => tab.dataset.pesoMoment);
          this.panels = [...this.querySelectorAll('[data-peso-panel]')];
          this.indexButtons = [...this.querySelectorAll('[data-peso-index]')];
          this.form = this.querySelector('[data-peso-search-form]');
          this.input = this.querySelector('[data-peso-search-input]');
          this.suggestions = this.querySelector('[data-peso-suggestions]');
          this.refiner = this.querySelector('[data-peso-piece-refiner]');
          this.chipList = this.querySelector('[data-peso-chip-list]');
          this.boundClick = this.onClick.bind(this);
          this.boundSubmit = this.onSubmit.bind(this);
          this.boundKeydown = this.onKeydown.bind(this);
          this.boundFocus = this.openSuggestions.bind(this);
          this.boundOutside = this.onOutsidePointer.bind(this);
          this.boundBlockSelect = this.onBlockSelect.bind(this);
          this.boundPopstate = this.onPopstate.bind(this);
          this.addEventListener('click', this.boundClick);
          this.form?.addEventListener('submit', this.boundSubmit);
          this.gallery?.addEventListener('keydown', this.boundKeydown);
          this.input?.addEventListener('focus', this.boundFocus);
          document.addEventListener('pointerdown', this.boundOutside);
          document.addEventListener('shopify:block:select', this.boundBlockSelect);
          window.addEventListener('popstate', this.boundPopstate);
          this.hideLegacyCategoryNavigation();
          const requestedMoment = new URL(window.location.href).searchParams.get('peso_moment');
          const initialMoment = this.sequence.includes(requestedMoment) ? requestedMoment : this.dataset.defaultMoment;
          this.activate(initialMoment, false, false);
          this.renderChips();
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.boundClick);
          this.form?.removeEventListener('submit', this.boundSubmit);
          this.gallery?.removeEventListener('keydown', this.boundKeydown);
          this.input?.removeEventListener('focus', this.boundFocus);
          document.removeEventListener('pointerdown', this.boundOutside);
          document.removeEventListener('shopify:block:select', this.boundBlockSelect);
          window.removeEventListener('popstate', this.boundPopstate);
          this.initialized = false;
        }

        hideLegacyCategoryNavigation() {
          if (this.dataset.hideCategoryNavigation !== 'true') return;
          const categorySection = document.querySelector('.shopify-section--collection-list');
          if (categorySection) categorySection.hidden = true;
        }

        normalize(value) {
          return value.toLocaleLowerCase().replace(/[–—]/g, '-').replace(/\s+/g, ' ').trim();
        }

        momentDefinitions() {
          return [
            { key: 'promise', terms: ['proposal', 'engagement', 'promise', 'anniversary', 'commitment', 'love', 'הצעה', 'אירוסין', 'הבטחה', 'יום נישואין', 'מחויבות', 'אהבה'] },
            { key: 'welcome', terms: ['welcome', 'belong', 'new child', 'new baby', 'family', 'קבלה', 'שייכות', 'תינוק', 'משפחה'] },
            { key: 'celebration', terms: ['celebrate', 'celebration', 'birthday', 'thank', 'gratitude', 'friendship', 'חגיגה', 'יום הולדת', 'תודה', 'חברות'] },
            { key: 'milestone', terms: ['milestone', 'promotion', 'graduation', 'achievement', 'retirement', 'ציון דרך', 'קידום', 'סיום לימודים', 'הישג', 'פרישה'] },
            { key: 'new_chapter', terms: ['new chapter', 'new job', 'new home', 'reinvent', 'fresh start', 'for myself', 'פרק חדש', 'עבודה חדשה', 'בית חדש', 'התחלה חדשה', 'לעצמי'] },
            { key: 'memory', terms: ['memory', 'remembrance', 'legacy', 'remember', 'in honour', 'in honor', 'זיכרון', 'מורשת', 'הנצחה'] }
          ];
        }

        pieceDefinitions() {
          return [
            { key: 'rings', terms: ['ring', 'rings', 'טבעת', 'טבעות'] },
            { key: 'necklaces', terms: ['necklace', 'necklaces', 'pendant', 'pendants', 'שרשרת', 'שרשראות', 'תליון', 'תליונים'] },
            { key: 'earrings', terms: ['earring', 'earrings', 'עגיל', 'עגילים'] },
            { key: 'bracelets', terms: ['bracelet', 'bracelets', 'צמיד', 'צמידים'] }
          ];
        }

        findDefinition(query, definitions) {
          return definitions.find((definition) => definition.terms.some((term) => query.includes(term)));
        }

        parseQuery(value) {
          const query = this.normalize(value);
          const moment = this.findDefinition(query, this.momentDefinitions());
          const piece = this.findDefinition(query, this.pieceDefinitions());
          const shapes = [
            { key: 'round', terms: ['round', 'עגול', 'עגולה'] },
            { key: 'heart', terms: ['heart', 'לב'] },
            { key: 'princess', terms: ['princess', 'נסיכה'] },
            { key: 'oval', terms: ['oval', 'אובל'] }
          ];
          const metals = [
            { key: 'yellow gold', terms: ['yellow gold', 'זהב צהוב'] },
            { key: 'white gold', terms: ['white gold', 'זהב לבן'] },
            { key: 'rose gold', terms: ['rose gold', 'זהב ורוד'] }
          ];
          const shape = this.findDefinition(query, shapes);
          const metal = this.findDefinition(query, metals);
          const budgetMatch = query.match(/(?:under|below|up to|maximum|max|עד)\s*(?:₪|nis)?\s*([\d,]+)/i);
          const budget = budgetMatch ? Number(budgetMatch[1].replaceAll(',', '')) : null;
          const recognized = Boolean(moment || piece || shape || metal || budget);
          return { original: value.trim(), moment, piece, shape, metal, budget, recognized };
        }

        filterEntries() {
          return [...this.querySelectorAll('[data-peso-filter-value]')].map((entry) => ({
            element: entry,
            group: this.normalize(entry.dataset.group || ''),
            label: this.normalize(entry.dataset.label || ''),
            value: this.normalize(entry.dataset.value || ''),
            param: entry.dataset.param,
            rawValue: entry.dataset.value
          }));
        }

        groupMatches(kind, group) {
          if (kind === 'piece') return ['category', 'subcategory', 'product type', 'קטגוריה', 'סוג מוצר'].some((label) => group.includes(label));
          if (kind === 'shape') return ['shape', 'cut', 'צורה', 'חיתוך'].some((label) => group.includes(label));
          if (kind === 'metal') return ['metal', 'material', 'מתכת', 'חומר'].some((label) => group.includes(label));
          return false;
        }

        aliases(kind, key) {
          const values = {
            piece: {
              rings: ['ring', 'rings', 'engagement ring', 'טבעת', 'טבעות'],
              necklaces: ['necklace', 'necklaces', 'pendant', 'pendants', 'שרשרת', 'שרשראות', 'תליון', 'תליונים'],
              earrings: ['earring', 'earrings', 'עגיל', 'עגילים'],
              bracelets: ['bracelet', 'bracelets', 'צמיד', 'צמידים']
            },
            shape: {
              round: ['round', 'עגול', 'עגולה'],
              heart: ['heart', 'לב'],
              princess: ['princess', 'נסיכה'],
              oval: ['oval', 'אובל']
            },
            metal: {
              'yellow gold': ['yellow gold', '14k yellow gold', 'זהב צהוב'],
              'white gold': ['white gold', '14k white gold', 'זהב לבן'],
              'rose gold': ['rose gold', '14k rose gold', 'זהב ורוד']
            }
          };
          return values[kind]?.[key] || [key];
        }

        findFilter(kind, key) {
          const aliases = this.aliases(kind, key).map((value) => this.normalize(value));
          return this.filterEntries().find((entry) => {
            if (!this.groupMatches(kind, entry.group)) return false;
            return aliases.some((alias) => entry.label === alias || entry.value === alias || entry.label.includes(alias));
          });
        }

        onSubmit(event) {
          const parsed = this.parseQuery(this.input?.value || '');
          if (!parsed.original) return;
          if (!parsed.recognized) return;
          event.preventDefault();
          const url = new URL(this.dataset.collectionUrl, window.location.origin);
          const unresolved = [];
          if (parsed.moment) url.searchParams.set('peso_moment', parsed.moment.key);
          for (const [kind, definition] of [['piece', parsed.piece], ['shape', parsed.shape], ['metal', parsed.metal]]) {
            if (!definition) continue;
            const filter = this.findFilter(kind, definition.key);
            if (filter) url.searchParams.append(filter.param, filter.rawValue);
            else unresolved.push(definition.key);
          }
          if (parsed.budget) {
            const priceFilter = this.querySelector('[data-peso-price-filter]');
            if (priceFilter?.dataset.maxParam) url.searchParams.set(priceFilter.dataset.maxParam, String(parsed.budget));
            else unresolved.push(String(parsed.budget));
          }
          if (unresolved.length) url.searchParams.set('peso_words', unresolved.join(', '));
          url.hash = 'catalog';
          window.location.assign(url);
        }

        onClick(event) {
          const suggestion = event.target.closest('[data-peso-suggestion]');
          if (suggestion) {
            this.input.value = suggestion.dataset.pesoSuggestion;
            this.form.requestSubmit();
            return;
          }
          const moment = event.target.closest('[data-peso-moment]');
          if (moment) {
            this.activate(moment.dataset.pesoMoment, true, true);
            return;
          }
          const index = event.target.closest('[data-peso-index]');
          if (index) {
            this.activate(index.dataset.pesoIndex, true, true);
            return;
          }
          if (event.target.closest('[data-peso-previous]')) {
            this.move(-1);
            return;
          }
          if (event.target.closest('[data-peso-next]')) {
            this.move(1);
            return;
          }
          const action = event.target.closest('[data-peso-action]')?.dataset.pesoAction;
          if (action === 'self') {
            const url = new URL(window.location.href);
            url.searchParams.set('peso_route', 'for_myself');
            window.history.replaceState({}, '', url);
            this.activate('new_chapter', true, true);
            this.renderChips();
            return;
          }
          if (action === 'close-refiner') {
            this.closeRefiner();
            return;
          }
          if (event.target.closest('[data-peso-refine]')) {
            this.toggleRefiner();
            return;
          }
          const piece = event.target.closest('[data-peso-piece]');
          if (piece) this.choosePiece(event, piece);
        }

        activate(key, focus, updateUrl) {
          if (!this.sequence.includes(key)) return;
          this.activeMoment = key;
          const activeTab = this.tabs.find((tab) => tab.dataset.pesoMoment === key);
          this.tabs.forEach((tab) => {
            const active = tab === activeTab;
            tab.classList.toggle('is-active', active);
            tab.setAttribute('aria-selected', String(active));
            tab.tabIndex = active ? 0 : -1;
          });
          this.panels.forEach((panel) => {
            panel.hidden = panel.dataset.pesoPanel !== key;
          });
          this.indexButtons.forEach((button) => {
            button.setAttribute('aria-pressed', String(button.dataset.pesoIndex === key));
          });
          this.querySelector('[data-peso-active-title]').textContent = activeTab.dataset.pesoTitle;
          this.querySelector('[data-peso-active-subtitle]').textContent = activeTab.dataset.pesoSubtitle;
          this.querySelector('[data-peso-active-description]').textContent = activeTab.dataset.pesoDescription;
          this.reorderTrack(key);
          const position = this.sequence.indexOf(key) + 1;
          const status = this.dataset.chapterStatus
            .replace('__INDEX__', String(position))
            .replace('__COUNT__', String(this.sequence.length))
            .replace('__TITLE__', activeTab.dataset.pesoSubtitle);
          this.querySelector('[data-peso-status]').textContent = status;
          if (updateUrl) {
            const url = new URL(window.location.href);
            url.searchParams.set('peso_moment', key);
            window.history.replaceState({}, '', url);
            this.renderChips();
          }
          if (focus) {
            activeTab.focus({ preventScroll: true });
            if (window.matchMedia('(max-width: 760px)').matches) activeTab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          }
        }

        reorderTrack(key) {
          const activeIndex = this.sequence.indexOf(key);
          const previous = key === 'promise' ? 'welcome' : this.sequence[(activeIndex - 1 + this.sequence.length) % this.sequence.length];
          const order = [previous, key];
          for (let offset = 1; order.length < this.sequence.length; offset += 1) {
            const candidate = this.sequence[(activeIndex + offset) % this.sequence.length];
            if (!order.includes(candidate)) order.push(candidate);
          }
          order.forEach((momentKey) => {
            const tab = this.tabs.find((candidate) => candidate.dataset.pesoMoment === momentKey);
            if (tab) this.track.append(tab);
          });
        }

        move(direction) {
          const activeIndex = this.sequence.indexOf(this.activeMoment);
          const nextIndex = (activeIndex + direction + this.sequence.length) % this.sequence.length;
          this.activate(this.sequence[nextIndex], true, true);
        }

        onKeydown(event) {
          if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          const rtl = getComputedStyle(this).direction === 'rtl';
          const direction = event.key === 'ArrowRight' ? 1 : -1;
          this.move(rtl ? direction * -1 : direction);
        }

        openSuggestions() {
          if (this.suggestions) this.suggestions.hidden = false;
        }

        onOutsidePointer(event) {
          if (!this.contains(event.target) && this.suggestions) this.suggestions.hidden = true;
        }

        toggleRefiner() {
          const button = this.querySelector('[data-peso-refine]');
          const open = this.refiner.hidden;
          this.refiner.hidden = !open;
          button.setAttribute('aria-expanded', String(open));
        }

        closeRefiner() {
          this.refiner.hidden = true;
          this.querySelector('[data-peso-refine]').setAttribute('aria-expanded', 'false');
        }

        choosePiece(event, control) {
          const key = control.dataset.pesoPiece;
          if (key === 'any') {
            event.preventDefault();
            const url = new URL(this.dataset.collectionUrl, window.location.origin);
            if (this.activeMoment) url.searchParams.set('peso_moment', this.activeMoment);
            url.hash = 'catalog';
            window.location.assign(url);
            return;
          }
          const filter = this.findFilter('piece', key);
          if (!filter) return;
          event.preventDefault();
          const url = new URL(this.dataset.collectionUrl, window.location.origin);
          if (this.activeMoment) url.searchParams.set('peso_moment', this.activeMoment);
          url.searchParams.append(filter.param, filter.rawValue);
          url.hash = 'catalog';
          window.location.assign(url);
        }

        renderChips() {
          if (!this.chipList) return;
          this.chipList.replaceChildren();
          const url = new URL(window.location.href);
          const momentKey = url.searchParams.get('peso_moment');
          const momentTab = this.tabs.find((tab) => tab.dataset.pesoMoment === momentKey);
          if (momentTab) this.addChip(momentTab.dataset.pesoSubtitle, 'moment', 'peso_moment', momentKey);
          if (url.searchParams.get('peso_route') === 'for_myself') this.addChip(this.dataset.routeSelfLabel, 'route', 'peso_route', 'for_myself');
          this.querySelectorAll('[data-peso-filter-value][data-active="true"]').forEach((entry) => {
            this.addChip(entry.dataset.label, 'filter', entry.dataset.param, entry.dataset.value);
          });
          const price = this.querySelector('[data-peso-price-filter]');
          if (price?.dataset.minValue) this.addChip(price.dataset.minLabel || price.dataset.minValue, 'filter', price.dataset.minParam, price.dataset.minValue);
          if (price?.dataset.maxValue) this.addChip(price.dataset.maxLabel || price.dataset.maxValue, 'filter', price.dataset.maxParam, price.dataset.maxValue);
          const words = url.searchParams.get('peso_words');
          if (words) this.addChip(words, 'words', 'peso_words', words);
          const understood = this.querySelector('[data-peso-understood]');
          understood.hidden = this.chipList.childElementCount === 0;
        }

        addChip(label, type, param, value) {
          const template = this.querySelector('[data-peso-chip-template]');
          const chip = template.content.firstElementChild.cloneNode(true);
          chip.querySelector('[data-peso-chip-label]').textContent = label;
          const remove = chip.querySelector('[data-peso-chip-remove]');
          remove.dataset.pesoChipType = type;
          remove.dataset.pesoChipParam = param;
          remove.dataset.pesoChipValue = value;
          chip.querySelector('[data-peso-chip-remove-label]').textContent = this.dataset.removeLabel.replace('__LABEL__', label);
          remove.addEventListener('click', () => this.removeChip(remove));
          this.chipList.append(chip);
        }

        removeChip(button) {
          const url = new URL(window.location.href);
          const param = button.dataset.pesoChipParam;
          const value = button.dataset.pesoChipValue;
          if (button.dataset.pesoChipType === 'filter') {
            const remaining = url.searchParams.getAll(param).filter((candidate) => candidate !== value);
            url.searchParams.delete(param);
            remaining.forEach((candidate) => url.searchParams.append(param, candidate));
            url.hash = 'catalog';
            window.location.assign(url);
            return;
          }
          url.searchParams.delete(param);
          window.history.replaceState({}, '', url);
          if (button.dataset.pesoChipType === 'moment') this.activate(this.dataset.defaultMoment, false, false);
          this.renderChips();
        }

        onBlockSelect(event) {
          const tab = this.tabs.find((candidate) => candidate.dataset.pesoBlockId === event.detail.blockId);
          if (tab) this.activate(tab.dataset.pesoMoment, false, false);
        }

        onPopstate() {
          const url = new URL(window.location.href);
          const moment = url.searchParams.get('peso_moment');
          this.activate(this.sequence.includes(moment) ? moment : this.dataset.defaultMoment, false, false);
          this.renderChips();
        }
      }

      customElements.define('peso-catalog-discovery', PesoCatalogDiscovery);
    }
  
  } catch(e) { console.error(e); }
})();
})();
